import { loading } from 'State/actions';
import * as types from './types';

export const getBasicSetup = resourceName => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.BASICSETUP_LOADING, true));

    try {
      const response = await MPWWebApi.getGeneric(resourceName);
      dispatch({
        type: types.BASICSETUP_GET,
        payload: response,
      });
    } catch (error) {
      dispatch({
        type: types.BASICSETUP_ERROR,
        payload: error.response,
      });
    }

    dispatch(loading(types.BASICSETUP_LOADING, false));
  };
};

export const postBasicSetupDelete = (resourceName, id, useQueryString) => {
  return async (dispatch, getState, MPWWebApi) => {
    return new Promise(async (resolve, reject) => {
      try {
        dispatch(loading(types.BASICSETUP_LOADING, true));
        const response = useQueryString
          ? await MPWWebApi.postGenericDeleteQueryString(resourceName, id)
          : await MPWWebApi.postGenericDelete(resourceName, id);
        dispatch(getBasicSetup(resourceName));
        dispatch(loading(types.BASICSETUP_LOADING, false));
        resolve({
          response,
          error: null,
        });
      } catch (error) {
        dispatch({
          type: types.BASICSETUP_ERROR,
          payload: error.response,
        });
        dispatch(loading(types.BASICSETUP_LOADING, false));
        reject();
      }
    });
  };
};

export const postBasicSetupInsertUpdate = (resourceName, basicSetup) => {
  return (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.BASICSETUP_LOADING, true));

    return new Promise((resolve, reject) => {
      MPWWebApi.postGenericInsertUpdate(resourceName, basicSetup)
        .then(response => {
          //Reload roles from the DB
          dispatch(getBasicSetup(resourceName));
          dispatch(loading(types.BASICSETUP_LOADING, false));
          resolve(response);
        })
        .catch(error => {
          dispatch({
            type: types.BASICSETUP_ERROR,
            payload: error.response,
          });
          //Reload roles from the DB
          dispatch(getBasicSetup(resourceName));
          dispatch(loading(types.BASICSETUP_LOADING, false));
          reject(error.response);
        });
    });
  };
};

export const clearBasicSetup = () => {
  return {
    type: types.BASICSETUP_CLEAR,
  };
};

export const updateBasicSetupCollection = item => {
  return {
    type: types.BASICSETUP_UPDATE_COLLECTION,
    payload: item,
  };
};



// WEBPACK FOOTER //
// ./src/components/basicsetup/state/actions.js